import axios from "axios";
import { useSelector } from "react-redux";
import { REACT_APP_MIRUM_SERVER_BASE_URL } from "config";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "redux/slices/auth";
import { loadTokenFromStorage } from "store/user-store";

function useAPI({ useAdminPrefix }) {
  const user = useSelector((state) => state.user);
  const tempSessionId = useSelector((state) => state.auth.tempSessionId);
  const history = useHistory();
  const dispatch = useDispatch();
  
  // Get token from localStorage
  const getAuthToken = () => {
    return loadTokenFromStorage();
  };

  // Build baseURL
  let baseURL = REACT_APP_MIRUM_SERVER_BASE_URL + "/api";
  useAdminPrefix = useAdminPrefix || false;
  if (useAdminPrefix) {
    baseURL = baseURL + "/admin";
  }

  // Create axios instance with baseURL
  const apiClient = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  const BASE_CONFIG = {
    headers: {
      tempSessionId: tempSessionId,
      ...(getAuthToken() && { Authorization: `Bearer ${getAuthToken()}` }),
    },
  };

  const handleError = (e) => {
    console.error("e", e);
    if (e?.response?.status === 403) {
      console.log("logout");
      dispatch(logout());
      history.push("/login");
    }
  };

  const get = async (url, config) => {
    console.log("user state", user);
    config = config || {};
    const requestConfig = {
      ...BASE_CONFIG,
      ...config,
      headers: {
        ...BASE_CONFIG.headers,
        ...(config.headers || {}),
        ...(getAuthToken() && { Authorization: `Bearer ${getAuthToken()}` }),
      },
    };
    try {
      console.log("Call url", url, "with config", requestConfig);
      let response = await apiClient.get(url, requestConfig);
      return response.data;
    } catch (e) {
      handleError(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  const post = async (url, body, config, interceptHandleError) => {
    config = config || {};
    const requestConfig = {
      ...BASE_CONFIG,
      ...config,
      headers: {
        ...BASE_CONFIG.headers,
        ...(config.headers || {}),
        ...(getAuthToken() && { Authorization: `Bearer ${getAuthToken()}` }),
      },
    };
    try {
      console.log("Call url", url, "with config", requestConfig);
      let response = await apiClient.post(url, body, requestConfig);
      return response.data;
    } catch (e) {
      interceptHandleError ? interceptHandleError(e) : handleError(e);
      return null;
    } finally {
      console.log("Done with API Call");
    }
  };

  const put = async (url, body, config) => {
    config = config || {};
    const requestConfig = {
      ...BASE_CONFIG,
      ...config,
      headers: {
        ...BASE_CONFIG.headers,
        ...(config.headers || {}),
        ...(getAuthToken() && { Authorization: `Bearer ${getAuthToken()}` }),
      },
    };
    try {
      console.log("Call url", url, "with config", requestConfig);
      let response = await apiClient.put(url, body, requestConfig);
      return response.data;
    } catch (e) {
      handleError(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  const del = async (url, config) => {
    config = config || {};
    const requestConfig = {
      ...BASE_CONFIG,
      ...config,
      headers: {
        ...BASE_CONFIG.headers,
        ...(config.headers || {}),
        ...(getAuthToken() && { Authorization: `Bearer ${getAuthToken()}` }),
      },
    };
    try {
      console.log("Call url", url, "with config", requestConfig);
      let response = await apiClient.delete(url, requestConfig);
      return response.data;
    } catch (e) {
      handleError(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  return {
    API: {
      get,
      post,
      put,
      del,
    },
  };
}

export default useAPI;
